<app-ic-header></app-ic-header>

<div *ngIf="isLeftMenuRoute()" class="ic-main-event">
    <div  class="split1 top" [ngStyle]="{'background-color':settingsData?.event_bg_main_color}">
        <div class="menu-left" [ngStyle]="{'background-color':settingsData?.event_bg_secondary_color}">
            <app-event-menu></app-event-menu>
        </div>
        <ng-container>
        <div class="split right" [ngStyle]="{'background-color':settingsData?.event_bg_main_color}">
            <div class="p-20 pb-40">
                <router-outlet></router-outlet>
            </div>
            <div class="p-0" *ngIf="!leftMenu">
                <!-- <app-website-footer></app-website-footer> -->
                <app-ic-footer></app-ic-footer>
            </div>
        </div>
        </ng-container>
    </div>
</div>

<div [ngStyle]="containerStyles" *ngIf="!isLeftMenuRoute()" class="custom-scroll" [ngClass]="{'claim-ticket-offset': router.url.includes('claim-tickets')}">
    <router-outlet></router-outlet>
</div>
<div *ngIf="is_show_musicPlayer">
    <app-music-player></app-music-player>
</div>
<!-- <ng-container
    *ngIf="!is_album && !settingsData.is_preview && (!router.url.includes('/playlist')) && !router.url.includes('/preview') && appType !='native'">
    <app-ic-footer></app-ic-footer>
</ng-container> -->
<ng-container *ngIf="showFooter">
    <app-ic-footer></app-ic-footer>
</ng-container>